import {
  isOfflineLocalSession,
  StreamingStatus,
  type QuerySessionResponse,
} from '../../contracts';

// A session refetch resets `streamingStatus` to NOT_STARTED on its cache entry.
// Refetch only after generation has settled so the stream's chunk-apply guard
// cannot lose its in-flight state and freeze the note. Enumerating the settled
// set keeps future generation phases conservatively in the "don't refetch" bucket.
const SETTLED_STATUSES = new Set<StreamingStatus>([
  StreamingStatus.NOT_STARTED,
  StreamingStatus.MANUALLY_ABORTED,
  StreamingStatus.GENERATION_FAILED,
]);

/**
 * Whether a forced session GET is safe for the cached session.
 *
 * A cold cache fetches regardless, while local-only offline sessions must never
 * hit the backend because no server record exists for their synthetic ID.
 */
export function shouldForceSessionRefetch(
  cached: QuerySessionResponse | undefined
): boolean {
  if (isOfflineLocalSession(cached)) return false;

  const status = cached?.streamingStatus;
  if (status === undefined) return true;
  return SETTLED_STATUSES.has(status);
}
